import { Competition, GetParticipantDto, Participant, Result, Discipline, Startgroup, CompetitionIdAndTagDto, GetDisciplineDto, ParticipantDto, ResultList, ResultDto, GetResultsDto, StartnumberRfidTag, RfidFetchResponse, ResultPostPutStartnumberDto, TagreadEntity, TagreadModel, TagreaderModel, CompetitionDto, DisciplineStartgroupMapDto, LotteryDto, LotteryWinnersDto, ResultListFrmDto, DistinctTagreadDto } from "./Dtos";
import { timeInMsToString} from "../Services/ResultService";
import axios from './AxiosConfig';
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";

type Competitionid = number;

export const GET = {
    allCompetitions: async () => {
      const response: AxiosResponse<Array<CompetitionIdAndTagDto>> = await axios.get("/api/competitions");
      return {competitions: response.data}
    },

    getCompetitionWithDisciplinesAndStartgroups: async (competitionId: number) => {
      const competitionResponse = await getCompetition(competitionId);
      const disciplinesResponse = await getDisciplines(competitionId);
      const startgroupsResponse = await getStartgroupsInCompetition(competitionId);

      const disciplines: Array<Discipline> = disciplinesResponse.data.map(d => ({...d, startgroups: []})).sort((a,b) => a.displayOrder - b.displayOrder);
      const startgroups: Array<Startgroup> = startgroupsResponse.data.sort((a, b) => a.starttime_planned - b.starttime_planned);

      for (let i = 0; i < disciplines.length; i++) {
        const startgroupsResponse = await getStartgroupsInDiscipline(disciplines[i].id);
        disciplines[i].startgroups = startgroupsResponse.data;
      }
      return {...competitionResponse.competition, disciplines: disciplines, startgroups: startgroups} as Competition;
    },

    allStartgroupsInCompetition: async (competitionId: number) => {
      return (await getStartgroupsInCompetition(competitionId)).data;
    },

    allDisciplineStartgroupMaps: async () => {
      return (await getDisciplineStartgroupMaps()).data;
    },

    allStartgroups: async () => {
      return (await getStartgroups()).data;
    },

    allStartgroupsInDiscipline: async (disciplineId: number) => {
      return getStartgroupsInDiscipline(disciplineId);
    },

    allParticipants: async (competitionId: number, disciplines: Array<Discipline>, startgroupsInCompetition: Array<Startgroup>) => {
        const response: AxiosResponse<Array<ParticipantDto>> = await axios.get("/api/competition/" + competitionId + "/participants");
        const mappedData : Array<Participant> = response.data.map((p) => {
          const disciplineSelection = disciplines.filter(d => d.id === p.disciplineId);
          const disciplineName = disciplineSelection[0]?.name ?? "None";

          const startgroups = startgroupsInCompetition.filter(s => s.id === p.startgroupId) ?? [];
          const startgroup = startgroups.length > 0 ? new Date(startgroups[0].starttime_planned) : null; 
          return {
            ...p, 
            disciplineName: disciplineName,
            startgroup: startgroup
          } as Participant
        });
        return {participants: mappedData} as GetParticipantDto
    }, 

    allResultLists: async (competitionTag: string, startgroups: Array<Startgroup>) => {
      return getResults(competitionTag, startgroups);
    },

    allReportableResults: async (competitionTag: string, startgroups: Array<Startgroup>) => {
      const results = await getResults(competitionTag, startgroups).then((response) => {
        return response.flatMap(startlist => startlist.results);
      })
      return {results: results} as GetResultsDto;
    },
    allStartnumberRfidTags: async (competitionId: number) => {
      const response: Array<StartnumberRfidTag> = await axios.get(`/api/competition/${competitionId}/rfidtags`)
      .then((r: AxiosResponse<Array<StartnumberRfidTag>>) => {
        return r.data;
      })
      .catch(() => {
        return [] as Array<StartnumberRfidTag>;
      });
      return response;
    },
    fetchRfidTags: async (numberOfAntennasInUse: number, antennas: Array<string>, from?: number ) => {
      let url = `/api/rfidtagreads`;
      const twoSecondsAgo = (new Date()).getTime() - 2000;

      if (antennas.length > 0) {
        const antennasString = antennas.map(a => `antenna=${a}`).join("&");
        url = `${url}?${antennasString}&from=${from || twoSecondsAgo}&antennaCount=${numberOfAntennasInUse}`;
      }
      else {
        url = `${url}?from=${from || twoSecondsAgo}&antennaCount=${numberOfAntennasInUse}`;
      }

      const response: RfidFetchResponse = await axios.get(url)
        .then((r: AxiosResponse<RfidFetchResponse>) => {
          return r.data;
        })
        .catch(() => {
          return {antennaReads: [], responseTimestamp: from ?? twoSecondsAgo} as RfidFetchResponse;
        });

      return response;
    },
    allTagreads: async () => {
      return getTagreads();
    },
    distinctTagreadsByStartgroup: async (startgroup: string) => {
      return getDistinctTagreadsByStartgroup(startgroup);
    },
    allLotteriesInCompetition: async (competitionId: number) => {
      return (await getLotteriesInCompetition(competitionId)).data;
    }, 
    allLotteryWinnersInLottery: async (lotteryId: number) => {
      return (await getLotteryWinnersInLottery(lotteryId)).data;
    }, 
    allResultRptListsInCompetition: async (competitionTag: string) => {
      return (await getResultRptListsInCompetition(competitionTag)).data;
    }    

};


export const PUT = {
    startnumberRfidTag: async (id: number, tagName: string, startnumber: number) => {
      return await axios.put(`/api/rfidtag/${id}`, {tag: tagName, startnumber: startnumber})
        .then((r: AxiosResponse<StartnumberRfidTag>) => {
        return r.data;
      });
    },
    participantAutoAssignStartgroups: async (competitionId: number) => {
      await axios.put(`/api/competition/${competitionId}/participants/autoassign/startgroups`).then(() => {
        toast.success(`Auto tilldelning av startgrupper är slutförd`);
      });
      return true;
    },
    participantStartgroup: async (participantId: number, startgroupId: number) => {
      await axios.put(`/api/participant/${participantId}/startgroup/${startgroupId}`);
      return true;
    },
    result: async (result: Result, competitionTag: string) => {
      console.log("IMPLEMENT PUT.result(...)");
      var rtn = await axios.put("/api/competition/" + competitionTag + "/results", result);
      console.info('rtn put.result: ' + rtn);
      return true;
    },
    resultPutPost: async (newManResult: ResultPostPutStartnumberDto, competitionTag: string) => {
      console.log("IMPLEMENT PUT.resultPostPutStartnumber(...)");
      var rtn = await axios.put("/api/competition/" + competitionTag + "/resultbystartnumber", newManResult);
      //console.log(`Time: ${timeInMsToString(result.result)} -- ${result.result}`);
      return true;
    },
    startgroup: async (startgroup: Startgroup, competitionid: Competitionid) => {
      console.log("startgroup",startgroup);
      var rtn = await axios.put(`/api/startgroup/${startgroup.id}`, startgroup);
      return true;
    },
    startgroupRtn: async (startgroupRtn: Startgroup) => {
      console.log("IMPLEMENT PUT.startgroupRtn(...)");
      return true;
    },    
    discipline: async (discipline: Discipline, competitionid: Competitionid) => {
      console.info('PUT.discipline: ' + discipline.id.toString() + ', competition_id: ' + competitionid.toString());
      var rtn = await axios.put("/api/discipline/update/" + discipline.id.toString(), discipline);
      console.info('rtn: ' + rtn);
      return true},
    disciplineRtn: async (disciplineRtn: Discipline) => {
      console.log('disciplineRtn');
      return true
    },   
    competition: async (competition: Competition) => {
      console.info('PUT.competition: ' + competition.id.toString());
      var rtn = await axios.put("/api/competition/update/" + competition.id.toString(), competition);
      console.info('rtn: ' + rtn);
      return true},
    lottery: async (lottery: LotteryDto, competitionid: Competitionid) => {
      console.log("lottery",lottery);
      var rtn = await axios.put(`/api/lottery/${lottery.id}`, lottery);
      return true;
    }, 
    resultRptList: async (resultRptList: ResultListFrmDto, competitionTag: string) => {
      console.log("resultRptList",resultRptList);
      var rtn = await axios.put(`/api/resultlist/${resultRptList.id}`, resultRptList);
      return true;
    },     
    // result: async (result: Result) => {
    //   console.log('result');
    //   return true
    // }    
}

export const DELETE = {
  disciplineStartgroupMapping: async (id: number) => {
    const response = await axios.delete(`/api/startgroupmap/${id}`)
        .then((r: AxiosResponse<DisciplineStartgroupMapDto>) => {
          return r.data;
        });
    return response;
  },
    startnumberRfidTags: async (competitionId: number, tagName: string) => {
      return axios.delete(`/api/competition/${competitionId}/rfidtag/${tagName}`)
        .then((r: AxiosResponse<Array<StartnumberRfidTag>>) => {
          console.log("PARSED", r.data);
        return r.data;
      });
    },
    participant: async (participant: Participant) => {
      console.info('IMPLEMENT DELETE.participant: ' + participant.id);
      //var rtn = await axios.delete("/api/discipline_signedup/" + participant.id.toString()); 
      return true;
    },
    competition: async (competition: Competition) => {
      console.info('IMPLEMENT DELETE.competition: ' + competition.id);
      //var rtn = await axios.delete("/api/competition/" + competition.id.toString()); 
      return true;
    },
    startgroup: async (startgroup: Startgroup) => {
        var rtn = await axios.delete(`/api/startgroup/${startgroup.id}`); 
        return true;
      }, 
    result: async (result: Result) => {
      console.info('rtn: ' + result.id.toString() + ', ' + result.startnumber + ', ' + result.firstname);
      var rtn = await axios.delete("/api/result/" + result.id.toString());
      console.info('rtn: ' + rtn);  
      return true;
    },
    lottery: async (lottery: LotteryDto) => {
        var rtn = await axios.delete(`/api/lottery/${lottery.id}`); 
        return true;
      }, 
    lotteryWinnersByLotteryId: async (lotteryId: number) => {
        var rtn = await axios.delete(`/api/lottery/${lotteryId}/winners`); 
        return true;
      }, 
    resultRptList: async (resultRptList: ResultListFrmDto) => {
        var rtn = await axios.delete(`/api/resultlist/${resultRptList.id}`); 
        return true;
      },       
}

export const POST = {
  disciplineStartgroupMapping: async (startgroupId: number, disciplineId: number) => {
    const response = await axios.post(`/api/startgroupmap?disciplineid=${disciplineId}&startgroupid=${startgroupId}`)
        .then((r: AxiosResponse<DisciplineStartgroupMapDto>) => {
          return r.data;
        });
    return response;
  },

  startnumberRfidTag: async (competitionId: number, startnumber: number, tag: string) => {
    const response = await axios.post(`/api/competition/${competitionId}/rfidtag`, {tag: tag, startnumber: startnumber})
        .then((r: AxiosResponse<StartnumberRfidTag>) => {
          return r.data;
        });
    return response;
  },
  participant: async (participant: Participant, competitionid: Competitionid) => {
    console.info('IMPLEMENT POST.participant: ' + participant.id + ', Namn: ' + participant.firstname + ' ' + participant.lastname + ', competition_id: ' + competitionid.toString());
    //const rtnP = await axios.post("/api/discipline_signedup/add/participantDTO/competitionid/" + competitionid.toString(), participant);
    //const createdParticipant = rtnP.data;
    //console.info('createdParticipant.id: ' + createdParticipant.id.toString());
    //participant.id = createdParticipant.id;
    return true;
  },
  result: async (result: Result) => {
    console.log(`IMPLEMENT POST.result(...), Time: ${timeInMsToString(result.startTime)} -- ${result.finishTime}`);
    return true;
  },
  startgroup: async (startgroup: Startgroup) => {    
    //console.info('IMPLEMENT POST.startgroup(...): ' + startgroup.id + ', starttime_planned: ' + startgroup.starttime_planned.toString() + ', competition_id: ' + competitionid.toString());
    const rtnSg = await axios.post("/api/startgroup", startgroup);
    const createdStartgroup = rtnSg.data;
    console.info('createdStartgroup.id: ' + createdStartgroup.id.toString());
    startgroup.id = createdStartgroup.id;
    return true;
  },
    startgroupRtn: async (startgroupRtn: Startgroup) => {
      console.log('IMPLEMENT POST.startgroupRtn(...): ' + startgroupRtn.id.toString());
      return true;
  },
  tagread: async (tagreaderModel: TagreaderModel) => {    
    const rtnTr = await axios.post("/api/tagread", tagreaderModel);
    //const createdTagread = rtnTr.data;
    //console.info('createdTagread.id: ' + createdTagread.id.toString());
    return true;
  },
    lottery: async (lottery: LotteryDto) => {    
    //console.info('IMPLEMENT POST.lottery(...): ' + lottery.id + ', nrOfWinners: ' + lottery.nrOfWinners);
    const rtnSg = await axios.post("/api/lottery", lottery);
    const createdLottery = rtnSg.data;
    console.info('createdLottery.id: ' + createdLottery.id.toString());
    lottery.id = createdLottery.id;
    return true;
  },
    lotteryDraw: async (lotteryId: number) => {
    // adjust the path to whatever your server expects
    const resp = await axios.post(`/api/lottery/${lotteryId}/draw`);
    // assume the server returns `true` on success (or the list of winners)
    return resp.data;
  },
    resultRptList: async (resultRptList: ResultListFrmDto) => {    
    //console.info('IMPLEMENT POST.resultRptList(...): ' + resultRptList.id);
    const rtnSg = await axios.post("/api/resultlist", resultRptList);
    const createdResultRptList = rtnSg.data;
    console.info('createdResultRptList.id: ' + createdResultRptList.id.toString());
    resultRptList.id = createdResultRptList.id;
    return true;
  },

  /* discipline: async (discipline: Discipline, competitionid: Competitionid) => {    
    console.info('POST.discipline: ' + discipline.id + ', discipline.name: ' + discipline.name + ', competition_id: ' + competitionid.toString());
    const rsp = await axios.post("/api/discipline/add/competitionid/" + competitionid.toString(), discipline);
    const createdDiscipline = rsp.data;
    console.info('createdDiscipline: ' + createdDiscipline.id);
    discipline.id = createdDiscipline.id;
    return true},
    disciplineRtn: async (disciplineRtn: Discipline) => {
      console.log('disciplineRtn: ' + disciplineRtn.id.toString());
      return true
  },
  competition: async (dbCompetition: Competition) => {
    console.info('POST.competition: ' + dbCompetition.id.toString() + ', Name: ' + dbCompetition.name);
    const newDbCompetition = {
      id: -1,
      tag: dbCompetition.tag,
      name: dbCompetition.name,
      description: dbCompetition.description,
      start_time: dbCompetition.start_time,
      end_time: dbCompetition.end_time,
      deleted: dbCompetition.deleted,
    }

    try { 
      const response = await axios.post('/api/competition', newDbCompetition); 
      const createdCompetition = response.data; 
      //console.info('Created Competition ID: ' + createdCompetition.id); 
      dbCompetition.id = createdCompetition.id;
      return true;
    } catch (error) { 
      console.error('Error creating competition:', error); 
      return false;
    }
    //console.info('rtn.data: ' + rtn. + ', newDbCompetition.id: ' + newDbCompetition.id.toString());
    },
  addCompetition: async (resultCompetition: Competition) => {
    console.info('newCompetition: id: ' + resultCompetition.id.toString() + ', name: ' + resultCompetition.name);
    return true
  }
    */
}


const getCompetition = async (competitionId: number) => {
      const response: AxiosResponse<CompetitionDto> = await axios.get("/api/competitionbyid/" + competitionId);
      return {competition: response.data}
}

const getDisciplines = async (competitionId: number) => {
      const response: AxiosResponse<Array<GetDisciplineDto>> = await axios.get("/api/competition/" + competitionId + "/disciplines");
      return response;
}

const getStartgroups = async () => {
  const response: AxiosResponse<Array<Startgroup>> = await axios.get("/api/startgroups");
  return response;
}

const getStartgroupsInCompetition = async (competitionId: number) => {
  const response: AxiosResponse<Array<Startgroup>> = await axios.get("/api/competition/" + competitionId + "/startgroups");
  return response;
}

const getDisciplineStartgroupMaps= async () => {
  const response: AxiosResponse<Array<DisciplineStartgroupMapDto>> = await axios.get("/api/startgroupmaps");
  return response;
}

const getStartgroupsInDiscipline = async (disciplineId: number) => {
  const response: AxiosResponse<Array<Startgroup>> = await axios.get("/api/discipline/" + disciplineId + "/startgroups");
  return response;
}


const getResults = async (competitionTag: string, startgroups: Array<Startgroup>) => {
      const response: Promise<Array<ResultList<Result>>> = axios.get("/api/competition/" + competitionTag+ "/results").then(
        (resultLists: AxiosResponse<Array<ResultList<ResultDto>>>) => {
          return resultLists.data.map((resultList => {
            const orginalResults = [...resultList.results];
            const convertedResultList = {...resultList, results: []} as ResultList<Result>;
            for (const result of orginalResults) {
              const startgroupFiltered = startgroups.filter(s => s.id == result.startgroupId);
              const startgroupPlannedDate = startgroupFiltered ? new Date(startgroupFiltered[0].starttime_planned) : null;

              convertedResultList.results.push({
                birthYear: result.birthYear,
                clubOrTeam: result.clubOrTeam,
                disciplineName: result.disciplineName,
                distanceInMeters: result.distanceInMeters,
                finishTime: result.finishTime,
                startTime: result.startTime,
                firstname: result.firstname,
                lastname: result.lastname,
                gender: result.gender,
                startnumber: result.startnumber,
                id: result.id,
                startgroup: startgroupPlannedDate
              });
            }
            return convertedResultList;
          }))
        }
      );
      return response;
}

const getTagreads = async () => {
  const response: AxiosResponse<Array<TagreadEntity>> = await axios.get("/api/tagreads");
  return response.data;
}

const getDistinctTagreadsByStartgroup = async (startgroup: string) => {
  const encodedStartgroup = encodeURIComponent(startgroup);
  console.info('Fetching distinct tagreads for startgroup: ' + encodedStartgroup);
  const response: AxiosResponse<Array<DistinctTagreadDto>> = await axios.get(
    `/api/tagreads/distinctstartgroup/${encodedStartgroup}`
  );
  return response.data;
}

const getLotteriesInCompetition = async (competitionId: number) => {
  const response: AxiosResponse<Array<LotteryDto>> = await axios.get("/api/competition/" + competitionId + "/lotteries");
  return response;
}

const getLotteryWinnersInLottery = async (lotteryId: number) => {
  const response: AxiosResponse<Array<LotteryWinnersDto>> = await axios.get("/api/lottery/" + lotteryId + "/winners");
  return response;
}

const getResultRptListsInCompetition = async (competitionTag: string) => {
  const response: AxiosResponse<Array<ResultListFrmDto>> = await axios.get("/api/competition/" + competitionTag + "/resultlists");
  return response;
}